import LinkifyIt from "linkify-it";
import isString from "lodash/isString";
import truncate from "lodash/truncate";

import i18n from "../i18n";

export const pluralize = (count: number, noun: string, suffix = "s") => {
  const lang = i18n.language;
  if (lang === "en") {
    return `${noun}${count !== 1 ? suffix : ""}`;
  }
  return noun;
};

export const truncateString = (value: string, length?: number) => {
  const maxLength = length || 20;

  if (value && value.length >= maxLength) {
    return truncate(value, { length: maxLength });
  }

  return value;
};

export const formatBytes = (bytes: number) => {
  const units = ["B", "KB", "MB", "GB"];
  let value = bytes;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  return `${value.toFixed(value < 10 && unitIndex > 0 ? 1 : 0)} ${units[unitIndex]}`;
};

/** wa.me takes the number as digits only - no "+", spaces, dashes or brackets. */
export const getWhatsappUrl = (phone: string) =>
  `https://wa.me/${phone.replace(/\D/g, "")}`;

export const Regexes = {
  EMAIL_REGEX: /^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*$/,
  NAME_REGEX:
    /^(?![-._\s])[a-zA-Z0-9\u0600-\u06FF\u0750-\u077F\u08A0][-._a-zA-Z0-9\u0600-\u06FF\u0750-\u077F\u08A0\s]{1,18}(?<![-._\s])$/,
  URL_REGEX:
    /^\s*(https?:\/\/)?(([a-zA-Z0-9-]+\.)+[a-zA-Z0-9-]{2,6}|((([0-9]{1,3}\.){3}[0-9]{1,3}))(:[0-9]{1,5})?)(\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?\s*$/,
  PHONE_REGEX: /^\s*[+]?([0-9\s-]{7,})\s*$/,
  DOMAIN_REGEX:
    /^\s*(?!-)(?!.*-$)(?!.*--)[A-Za-z0-9-]{1,63}(\.[A-Za-z0-9-]{1,63})*(\.[A-Za-z]{2,})\s*$/,
};

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

export const linkify = (text: string, doTruncate?: boolean) => {
  const linkify = new LinkifyIt();
  const style = `style="color: var(--atira-main); text-decoration: underline; text-underline-offset: 5px; direction: ltr;"`;

  let lastIndex = 0;
  let result = "";

  const matches = linkify.match(text) || [];

  matches.forEach((match) => {
    result += text.slice(lastIndex, match.index);

    let displayText = doTruncate ? truncateString(match.text) : match.text;
    let href = match.url;

    if (match.schema === "mailto:") {
      href = `mailto:${match.text}`;
    }

    result += `<a href="${href}" target="_blank" ${style}>${displayText}</a>`;

    lastIndex = match.lastIndex;
  });

  result += text.slice(lastIndex);

  return result;
};

export const isMediaURL = (content?: any) => {
  const OBJECT_ID_REGEX = /^[0-9a-fA-F]{24}$/;

  return (
    (isString(content) && OBJECT_ID_REGEX.test(content)) ||
    content instanceof File
  );
};
